
export const TIPO_NOTIFICACION_ENUM = {
    1: 'Resumen de Ingreso',
    2: 'Ingreso de Indicación',
    3: 'Cambio de Indicación',
    4: 'Confirmar Equipo',
    5: 'Cambio de Programa',
}